<template>
  <Layout>
    <PageHeader
      :title="'Duyurular'"
      :items="breadcrumbArray"
    ></PageHeader>
    <v-app>
      <div class="row">
        <div class="col-lg-12">
          <Results></Results>
        </div>
      </div>
    </v-app>
  </Layout>
</template>

<script>
import Layout from "@/pages/layout/main.vue";
import PageHeader from "@/components/page-header";
import Results from "@/components/management/announcement/Results.vue";

export default {
  page: {
    title: "Duyurular",
    meta: [{ name: "description", content: "Duyurular" }],
  },
  components: {
    Layout,
    PageHeader,
    Results,
  },
  data() {
    return {
      currentPage: 1,
      treeCategories: [],
      treeBrands: [],
      breadcrumbArray: [
        {
          text: "Yönetim",
          active: false,
        },
        {
          text: "Duyurular",
          active: true,
        },
      ],

    };
  },
  methods: {
  },
};
</script>